import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { GateMessageDTO } from '@/../client-generator/generated-clients/plants';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';

@Options({
  name: 'messageItem',
  props: {
    message: {
      type: Object as PropType<GateMessageDTO>,
      required: true,
    },
    disableActions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: { DialogConfirmDelete },
  emits: ['edit-message', 'delete-message'],
})
export default class MessageItem extends Vue {
  message!: GateMessageDTO;
  isVisibleDeleteMessageConfirm = false;
  disableActions!: boolean;
  getValidTime() {
    const dateFrom = this.getParsedDate(this.message.durationSince);
    const dateTo = this.getParsedDate(this.message.durationUntil);

    return `From ${dateFrom} to ${dateTo}`;
  }

  getParsedDate(date?: Date) {
    if (!date) return '-';
    const options: any = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    };
    return date.toLocaleString('en-GB', options);
  }

  handleEditMessage() {
    this.$emit('edit-message', this.message);
  }

  toggleDeleteMessageConfirm() {
    this.isVisibleDeleteMessageConfirm = !this.isVisibleDeleteMessageConfirm;
  }

  async handleDeleteMessage() {
    this.$emit('delete-message', this.message.id);
  }

}
